import { render, staticRenderFns } from "./VServices.vue?vue&type=template&id=976a43ea&lang=pug"
import script from "./VServices.vue?vue&type=script&lang=ts"
export * from "./VServices.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports